import { gql } from '@apollo/client'

export const GET_DIFY_USAGE_REPORT = gql`
  query GetDifyUsageReport($days: Int!, $organizationId: String!) {
    difyUsageReport(days: $days, organizationId: $organizationId) {
      organization_id
      period_days
      total_calls
      successful_calls
      error_calls
      timeout_calls
      success_rate
      total_tokens
      input_tokens
      output_tokens
      avg_latency_ms
      by_agent {
        agent_id
        agent_name
        calls
        tokens
        avg_latency_ms
      }
      by_status {
        success {
          count
          tokens
        }
        error {
          count
          tokens
        }
        timeout {
          count
          tokens
        }
      }
      daily_trend {
        date
        calls
        tokens
      }
      recent_logs {
        id
        created
        agent_id
        agent_name
        status
        input_tokens
        output_tokens
        total_tokens
        dify_latency_ms
        message_input
        dify_response
        error_detail
      }
    }
  }
`
